import * as actions from './actions';

export type State = {
  loading: boolean;
  data: Array<Record<string, any>>;
  error: object;
};

export default (state: State = { loading: false, data: [], error: {} }, action: any): State => {
  switch (action.type) {
    case actions.FETCH_ACTION_TILES:
      return {
        ...state,
        loading: true,
      };
    case actions.FETCH_ACTION_TILES_SUCCESS:
      return {
        ...state,
        data: action.payload,
      };
    case actions.FETCH_ACTION_TILES_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};
